var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-datepicker eu-zindex_4 eu-position_relative",attrs:{"id":"datepicker"}},[_c('input-date',{class:_vm.classList,attrs:{"aria-autocomplete":"off","id":_vm.id,"locale":_vm.locale,"value":_vm.dateModel}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }